import { Box, Container } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { useLocation } from "wouter";

import { AppTile, AppTilesWrapper } from "@nens/chakra/components";
import { Breadcrumbs } from "@nens/ldo/components";
import { useActionAllowed } from "@nens/ldo/hooks";

import ApiIcon from "../icons/api.svg?react";
import ImportIcon from "../icons/import.svg?react";
import InfoIcon from "../icons/info.svg?react";
import LinkIcon from "../icons/link.svg?react";
import ScenarioIcon from "../icons/scenario.svg?react";
import UsersIcon from "../icons/users.svg?react";

export default function HomePage() {
  const setLocation = useLocation()[1];
  const intl = useIntl();

  const actionAllowed = useActionAllowed(null);

  return (
    <Box w="100%">
      <Breadcrumbs
        crumbs={[
          { label: intl.formatMessage({ id: "pages.home", defaultMessage: "Home" }), href: "/" },
        ]}
      />
      <Container maxW={"7xl"} py={"24px"} justifyItems="center">
        <AppTilesWrapper spacing="2px" justify="left">
          <AppTile
            title={intl.formatMessage({ id: "pages.scenarios", defaultMessage: "Scenarios" })}
            onClick={() => setLocation("/scenarios")}
            color="white"
            bgColor="bij12_1.700"
            icon={ScenarioIcon}
          />
          <AppTile
            title={intl.formatMessage({ id: "pages.import", defaultMessage: "Import" })}
            onClick={() => setLocation("/import/new")}
            readonly={!actionAllowed("create") && !actionAllowed("bulk update")}
            color="white"
            bgColor="bij12_1.700"
            icon={ImportIcon}
          />
          <AppTile
            title={intl.formatMessage({ id: "pages.users", defaultMessage: "Users" })}
            onClick={() => {
              window.location.href = "/auth/management/users";
            }}
            readonly={!actionAllowed("manage users")}
            color="white"
            bgColor="bij12_1.700"
            icon={UsersIcon}
          />
          <AppTile
            title={intl.formatMessage({
              id: "pages.export_scenarios",
              defaultMessage: "Export Scenarios",
            })}
            onClick={() => setLocation("/export/scenarios")}
            color="white"
            bgColor="bij12_1.700"
            icon={LinkIcon}
          />
          <AppTile
            title={intl.formatMessage({
              id: "pages.export_composite",
              defaultMessage: "Export Composite Maps",
            })}
            onClick={() => setLocation("/export/composite")}
            color="white"
            bgColor="bij12_1.700"
            icon={LinkIcon}
          />
          <AppTile
            title={intl.formatMessage({
              id: "pages.export_ror",
              defaultMessage: "Export ROR Maps",
            })}
            onClick={() => setLocation("/export/ror")}
            color="white"
            bgColor="bij12_1.700"
            icon={LinkIcon}
          />
          <AppTile
            title={intl.formatMessage({
              id: "pages.api",
              defaultMessage: "API",
            })}
            onClick={() => setLocation("/api")}
            color="white"
            bgColor="bij12_1.700"
            icon={ApiIcon}
          />
          <AppTile
            title={intl.formatMessage({
              id: "pages.info",
              defaultMessage: "Contact and Documentation",
            })}
            onClick={() => setLocation("/info")}
            color="white"
            bgColor="bij12_1.700"
            icon={InfoIcon}
          />
        </AppTilesWrapper>
      </Container>
    </Box>
  );
}
